import React, { useState,useEffect } from 'react';
import './Invoice.css';
import { Box, Card, CardContent, Typography, MenuItem, Select,InputLabel,FormControl, IconButton, TextField, Grid, Button, Snackbar, Alert } from '@mui/material';
import { Delete, Add } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import axios, { decryptData } from '../Axiosinstance';
import { buttonBackgroundColor } from '../common';



const Container = () => {
  const { intakeId } = useParams();
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const [intakedata, setIntakedata] = useState([]);
  const [isDataChanged, setIsDataChanged] = useState(false); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/intake-details/intakeId/${intakeId1}`);
        if (response.data) {
          console.log('API Response:', response.data);
          setIntakedata(response.data);

          setFormData({
            days: response.data.intakeDetailsDays.map((day) => ({
              day: day.day,
              sessions: Object.entries(day.sessions).map(([sessionKey, sessionValue]) => ({
                session: sessionKey,
                startTime: sessionValue.startTime,
                endTime: sessionValue.endTime
              }))
            }))
          });
        } else {
          throw new Error('Data format is incorrect');
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };
    fetchData();
  }, [intakeId1]);

  const [formData, setFormData] = useState({
    days: [
      // {
      //   day: '',
      //   sessions: [{ session: '', startTime: '', endTime: '' }]
      // }
    ]
  });

  const [errors, setErrors] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];




  // Handle adding a new day with a default session
  const handleAddDay = () => {
    const newDay = {
      day: '',
      sessions: [{ session: '', startTime: '', endTime: '' }]
    };

    setFormData((prevData) => {
      setIsDataChanged(true); // Mark data as changed
      return {
        ...prevData,
        days: [...prevData.days, newDay]
      };
    });
  };

  // Handle adding a new session to an existing day
  const handleAddSession = (dayIndex) => {
    const newSession = { session: '', startTime: '', endTime: '' };

    setFormData((prevData) => {
      setIsDataChanged(true);
      const updatedDays = [...prevData.days];
      updatedDays[dayIndex].sessions.push(newSession);
      return { ...prevData, days: updatedDays };
    });
  };

  const handleChange = (event, dayIndex, sessionIndex) => {
    const { name, value } = event.target;
    setFormData((prevData) => {
      setIsDataChanged(true);
      const updatedDays = [...prevData.days];
      if (sessionIndex !== undefined) {
        updatedDays[dayIndex].sessions[sessionIndex][name] = value;
      } else {
        updatedDays[dayIndex][name] = value;
      }
      return { ...prevData, days: updatedDays };
    });

    // Clear the error for the specific field when modified
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${dayIndex}-${sessionIndex || ''}-${name}`]: ""
    }));
  };

  const handleRemoveDay = (dayIndex) => {
    setFormData((prevData) => {
      setIsDataChanged(true); // Mark data as changed
      return {
        ...prevData,
        days: prevData.days.filter((_, index) => index !== dayIndex)
      };
    });
  };

  const handleRemoveSession = (dayIndex, sessionIndex) => {
    setFormData((prevData) => {
      setIsDataChanged(true);
      const updatedDays = [...prevData.days];
      updatedDays[dayIndex].sessions = updatedDays[dayIndex].sessions.filter((_, index) => index !== sessionIndex);
      return { ...prevData, days: updatedDays };
    });
  };

  const validateFields = () => {
    const newErrors = {};
    formData.days.forEach((day, dayIndex) => {
      if (!day.day) {
        newErrors[`${dayIndex}-day`] = "Day is required.";
      }
      day.sessions.forEach((session, sessionIndex) => {
        if (!session.startTime) {
          newErrors[`${dayIndex}-${sessionIndex}-startTime`] = "Start time is required.";
        }
        if (!session.endTime) {
          newErrors[`${dayIndex}-${sessionIndex}-endTime`] = "End time is required.";
        }
      });
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getFormattedData = () => {
    return {
      days: formData.days.map((day) => ({
        day: day.day,
        sessions: day.sessions.reduce((acc, session, index) => {
          acc[`Session ${index + 1}`] = {
            startTime: session.startTime,
            endTime: session.endTime
          };
          return acc;
        }, {})
      }))
    };
  };

  const handleSave = async () => {
    if (!validateFields()) {
      setToastMessage("Please fill all required fields.");
      setToastSeverity("error");
      setToastOpen(true);
      return;
    }

    const intakeId = intakeId1;
    const url = `intake-details/${intakeId}/update-weeks`;

    const formattedData = getFormattedData();

    try {
      const response = await axios.put(url, formattedData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log('Response:', response.data);
      setToastMessage("Data saved successfully!");
      setToastSeverity("success");
      setToastOpen(true);
      window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
      setToastMessage("Failed to save data.");
      setToastSeverity("error");
      setToastOpen(true);
    }
  };

  return (
    <div className="container-fluid">
      <Box sx={{ maxWidth: '800px' }}>
        {formData.days.map((day, dayIndex) => (
          <Card key={dayIndex} sx={{ mb: 2, backgroundColor: '#ffffff', boxShadow: 1 }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Day {dayIndex + 1}</Typography>
                <IconButton onClick={() => handleRemoveDay(dayIndex)} color="error">
                  <Delete />
                </IconButton>
              </Box>
              <FormControl fullWidth margin="normal">
              <InputLabel id="select Day">Select The Day</InputLabel>
              <Select
                value={day.day}
                onChange={(e) => handleChange({ target: { name: 'day', value: e.target.value } }, dayIndex)}
                fullWidth
                labelId="select Day"
                label="Select The Day"
                error={Boolean(errors[`${dayIndex}-day`])}
                helperText={errors[`${dayIndex}-day`]}
              >
                {daysOfWeek.map((day) => (
                  <MenuItem key={day} value={day}>
                    {day.charAt(0).toUpperCase() + day.slice(1)}
                  </MenuItem>
                ))}
              </Select>
              </FormControl>

              {day.sessions.map((session, sessionIndex) => (
                <Box key={sessionIndex} mb={2}>
                  <Typography variant="subtitle1" gutterBottom>
                    Session {sessionIndex + 1}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <TextField
                        label="Start Time"
                        name="startTime"
                        type="time"
                        value={session.startTime}
                        onChange={(e) => handleChange(e, dayIndex, sessionIndex)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        required
                        error={Boolean(errors[`${dayIndex}-${sessionIndex}-startTime`])}
                        helperText={errors[`${dayIndex}-${sessionIndex}-startTime`]}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        label="End Time"
                        name="endTime"
                        type="time"
                        value={session.endTime}
                        onChange={(e) => handleChange(e, dayIndex, sessionIndex)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        required
                        error={Boolean(errors[`${dayIndex}-${sessionIndex}-endTime`])}
                        helperText={errors[`${dayIndex}-${sessionIndex}-endTime`]}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <IconButton onClick={() => handleRemoveSession(dayIndex, sessionIndex)} color="error">
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Box>
              ))}
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={() => handleAddSession(dayIndex)}
                fullWidth
              >
                Add Session
              </Button>
            </CardContent>
          </Card>
        ))}
        <Button
          variant="contained"
          style={{backgroundColor:buttonBackgroundColor}}
          startIcon={<Add />}
          onClick={handleAddDay}
          sx={{ mt: 2 }}
          fullWidth
        >
          Add Day
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleSave}
          sx={{ mt: 2 }}
          fullWidth
          disabled={!isDataChanged} // Disable if no changes
        >
          Save Data
        </Button>

        <Snackbar
          open={toastOpen}
          autoHideDuration={3000}
          onClose={() => setToastOpen(false)}
        >
          <Alert onClose={() => setToastOpen(false)} severity={toastSeverity} sx={{ width: '100%' }}>
            {toastMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Container;
